import { useT } from "../../i18n";
import Layout from "../../components/Layout";
import { Paper, Typography } from "@mui/material";
import MyAnwesenheitenDataTable from "../../components/anwesenheiten/MyAnwesenheitenDataTable";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import React from "react";
import Guard from "../../components/Guard";

export default function MeineAnwesenheiten() {
  const { t } = useT("taetigkeitsbericht");
  const limit = parseInt(
    localStorage.getItem("meine-anwesenheitenLimit") ?? "25",
    10
  );
  return (
    <Layout title="Meine Anwesenheiten" showTitleInNav={false}>
      <Guard
        permission={"meine:anwesenheit:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">Meine Anwesenheiten</Typography>
          <MyAnwesenheitenDataTable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
